<template>
    <vs-popup :active.sync="showPopup" :buttons-hidden="true">
      <div class="px-6 py-10 md:p-10">
        <img
            height="34"
            width="34"
            class="mr-5 float-left"
            src="@/assets/images/account-details/Question.svg"
        />
        <div class="md:flex md:flex-col">
            <p class="prompt-title mb-5 whitespace-no-wrap md:prompt-title">{{ title }}</p>
            <div class="prompt-body mb-4 ml-0">
              <p v-if="body"> {{ body }} </p>
               <p v-if="htmlBody" v-html="htmlBody"> </p>
              <slot v-else name="body"></slot>
            </div>
        </div>

        <div class="flex flex-wrap mt-10 md:justify-end btns">

            <!-- Confirm Button -->
            <slot name="confirmation">
              <vs-button
                @click="$emit('confirm')"
                class="w-full ok-btn mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last">
                {{ confirmationText || 'Yes' }}
              </vs-button>
            </slot>
            <!-- Confirm Button -->

            <!-- No Button -->
            <vs-button
                class="w-full cancel-btn md:cancel-btn"
                type="border"
                text-color="#2C2C2C"
                color="#D9D9D9"
                @click="$emit('hide-confirmation-popup')">
                {{ cancelText || 'No' }}
            </vs-button>

        </div>
      </div>
    </vs-popup>
</template>

<script>
export default {
  name: 'speakol-confirmation-popup',

  props: ['showConfirmationPopup', 'title', 'body', 'cancelText', 'confirmationText', 'htmlBody'],

  computed: {
    showPopup: {
      get () {
        return this.showConfirmationPopup
      },
      set () {
        return this.showConfirmationPopup
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .btns button {
    border-radius: 3px;
    height: 40px;

    .cancel-btn {
      background: #fff;
    }

    .ok-btn {
      background: #0092d7;
    }
  }

  .prompt-title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.1px;
    color: #2c2c2c;
  }

  .prompt-body {
    font-size: 14px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.56);
  }

  @media (min-width: 768px) {
    .md\:cancel-btn {
      min-width: 112px !important;
      max-width: 140px;
    }
  }

</style>
